var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2305,
    height: 327,
    viewBox: "0 0 2305 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.643 15.0989L0 32.3549V327H2305V0L1999.2 32.3549L1766.14 65.1412L1510.03 47.8852H1185L779.602 76.3575L409.266 47.8852L173.643 15.0989Z",
    fill: "url(#paint0_linear_83_95)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1159 50.6077C988 137.5 779.602 232.5 731 327H1563H1675.5C1675.5 327 1245.5 255.5 1185 47.8852L1159 50.6077Z",
    fill: "url(#paint1_linear_83_95)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_95",
    x1: 1152.5,
    y1: 0,
    x2: 1152.5,
    y2: 102.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86A840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8D053"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_83_95",
    x1: 1089.5,
    y1: 54,
    x2: 1089.5,
    y2: 327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B8B8B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector8);
export default __webpack_public_path__ + "static/media/Vector8.7ca7619f2a0c2babaac813979ad88c04.svg";
export { ForwardRef as ReactComponent };